import { render, staticRenderFns } from "./AddInsPath.vue?vue&type=template&id=a3b56032&scoped=true"
import script from "./AddInsPath.vue?vue&type=script&lang=js"
export * from "./AddInsPath.vue?vue&type=script&lang=js"
import style0 from "./AddInsPath.vue?vue&type=style&index=0&id=a3b56032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b56032",
  null
  
)

export default component.exports